import React from 'react';
import { connect } from 'react-redux';

import { DataLoader } from '../../../components/common/index';
import { getApplicationsData } from '../../../redux/actions/router/index';
import { RouterContext } from '../../../types/router';
import { errorLogger } from '../../../utils/error-logger/error-logger';
import { BI_ERRORS } from '../../../utils/statistics/bi-error-logger/bi-errors';

import { ApplicationsContainer } from './applications.lazy';

interface RouterParams {
  applicationId: string;
  organizationId: string;
  projectId: string;
}

interface Props {
  router?: RouterContext<RouterParams>;
  getApplicationsData(router: RouterContext<RouterParams>): Promise<void>;
}

export class ApplicationsDataLoader extends React.Component<Props> {
  private loadData(): Promise<void> {
    const { getApplicationsData, router } = this.props;

    if (router) {
      return getApplicationsData(router).catch(
        errorLogger.createLoggingCatcher(
          BI_ERRORS.applications.pageDataLoading,
        ),
      );
    }

    return Promise.reject({});
  }

  public render() {
    return (
      <DataLoader loadData={this.loadData.bind(this)}>
        {(props) => <ApplicationsContainer {...props} />}
      </DataLoader>
    );
  }
}

const mapStateToProps = null;

const mapDispatchToProps = (dispatch) => {
  return {
    getApplicationsData: (context) => dispatch(getApplicationsData(context)),
  };
};

export const Applications = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ApplicationsDataLoader);
